module.exports = __webpack_public_path__ + "img/medalha-empreendedor-rural.50fbfdb6.jpg";